import React, { useContext, useState } from "react";
import { Col, Row, Button, FormControl, Form } from "react-bootstrap";
import ComponentContext from "../Context";
import DocumentMeta from "react-document-meta";
import HeaderBanner from "../Components/HeaderBanner";
import Kargah from "../Images/kargah.png";
import Config from "../config.json";
export default () => {
  const page_meta = {
    language: "fa",
    copyright: "پژوهیار",
    description: "نرم‌افزار استناددهی",
    title: Config.title + " | ثبت نام کارگاه",
    meta: {
      charset: "utf-8",
      name: {
        keywords: "پژوهیار",
      },
    },
  };

  const context = useContext(ComponentContext);
  const body = `به منظور فراگیریِ بهتر پژوهیار، دوره‌های آموزشی در سه سطح در نظر گرفته شده است. برای
      درخواست کارگاه و کلاس آموزشی از طریق فرم تربیت‌مدرس، فرم سازمانی و فرم عمومی ثبت نام فرمایید.`;

  const [fullname, set_fullname] = useState("");
  const [phone, set_phone] = useState("");
  const [head_fullname, set_head_fullname] = useState("");
  const [head_phone, set_head_phone] = useState("");
  const [organization, set_organization] = useState("");
  const [email, set_email] = useState("");
  const [address, set_address] = useState("");
  const [description, set_description] = useState("");
  const [capacity, set_capacity] = useState("");
  const [duration, set_duration] = useState("");
  const [requesting, set_requesting] = useState(false);

  const registerWorkShop = () => {
    set_requesting(true);
    const formData = {};
    formData.fullname = fullname;
    formData.phone = phone;
    formData.head_fullname = head_fullname;
    formData.head_phone = head_phone;
    formData.organization = organization;
    formData.email = email;
    formData.address = address;
    formData.description = description;
    formData.capacity = capacity;
    formData.duration = duration;
    context.ApiDriver.orderWorkshop(
      formData,
      (data, meta) => {
        context.notification("سفارش با موفقیت ثبت شد", "success");
        set_requesting(false);
      },
      error => {
        context.notification("مشکلی در ارسال بوجود آمد.", "error");
        set_requesting(false);
        for (var err in error.response.data) {
          var element = document.getElementById(error.response.data[err].field);
          if (element) {
            element.className += " invalid-forminput";
          }
        }
      },
    );
  };

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner body={body} image={Kargah} header_color="#E5E1DA" />

      <Row style={{ padding: "50px 30px" }} className="mx-0">
        <Col className="cslformcontainer mx-0">
          <Row className="justify-content-center mx-0">
            <h3>سفارش کارگاه سازمانی</h3>
          </Row>
          <Row>
            <Col md={4}>
              <FormControl
                id="fullname"
                className="pr-3"
                required
                placeholder="نام و نام‌خانوادگی"
                onChange={e => {
                  set_fullname(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <FormControl
                id="phone"
                className="pr-3"
                required
                placeholder="تلفن"
                onChange={e => {
                  set_phone(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <FormControl
                id="head_fullname"
                required
                className="pr-3"
                placeholder="نام سرپرست"
                onChange={e => {
                  set_head_fullname(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormControl
                id="head_phone"
                className="pr-3"
                placeholder="تلفن سرپرست"
                onChange={e => {
                  set_head_phone(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <FormControl
                id="organization"
                className="pr-3"
                required
                placeholder="نام سازمان"
                onChange={e => {
                  set_organization(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <FormControl
                id="email"
                className="pr-3"
                required
                placeholder="ایمیل"
                onChange={e => {
                  set_email(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <FormControl
                id="capacity"
                className="pr-3"
                required
                placeholder="تعداد نفرات"
                onChange={e => {
                  set_capacity(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <FormControl
                id="duration"
                required
                className="pr-3"
                placeholder="مدت آموزش"
                onChange={e => {
                  set_duration(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <FormControl
                id="address"
                className="pr-3"
                required
                placeholder="نشانی"
                onChange={e => {
                  set_address(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group>
                <Form.Control
                  id="description"
                  as="textarea"
                  className="pr-3"
                  rows="3"
                  onChange={e => {
                    set_description(e.target.value);
                  }}
                  placeholder="توضیحات"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Row className="justify-content-end">
                <Button
                  bsPrefix="custom-button"
                  disabled={requesting}
                  onClick={registerWorkShop}
                  style={{ fontSize: 14 }}>
                  {requesting ? "..." : "ثبت سفارش"}
                </Button>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </DocumentMeta>
  );
};
